import router from '@/router'
import { loginRoute, forgotPasswordRoute, resetPasswordRoute } from '@/lib/constants/routes'
import { clearAllAuthentication } from '@/lib/authentication'

const PUBLIC_ROUTE_NAMES = [ loginRoute.name, forgotPasswordRoute.name, resetPasswordRoute.name ]

const validateResult = (res, body = null) => {
  if (!PUBLIC_ROUTE_NAMES.includes(router.history.current.name)) {
    if (res.statusCode === 401 || res.status === 401) {
      clearAllAuthentication()
      router.push({ name: loginRoute.name })
      return
    }

    if (res.statusCode >= 400 || res.status >= 400) {
      throw Error((body && body.errorMessage) || res.errorMessage)
    }
  }
}

export default validateResult
